<div #footer class="modal-footer primary-bg-color">
  <div class="footer-overlay visible-xs m-0"></div>
  <div class="button-controls text-right">
    <button
      ftsAuditableButton
      class='btn primary-bg-color action-text-color primary-bg-border-color text-uppercase action-btn fw-600 back-btn font-secondary previous-step-btn text-uppercase margin-right-10'
      (click)='onCancelBtnClick()'>
      <span class="arrow-left"></span>{{'component.step_controls.cancel' | translate}}
    </button>
    
    <button
      ftsAuditableButton
      *ngIf='hasBackBtn && ingredientChoicesType === ingredientChoicesTypeEnum.Steps'
      class='btn primary-bg-color action-text-color primary-bg-border-color text-uppercase action-btn fw-600 back-btn font-secondary previous-step-btn text-uppercase margin-right-10'
      (click)='onBackBtnClick()'>
      <span class="arrow-left"></span>{{'component.step_controls.back' | translate}}
    </button>

    <button
    ftsAuditableButton
      *ngIf='hasForwardBtn && ingredientChoicesType === ingredientChoicesTypeEnum.Steps'
      class='btn selection-bg-color selection-inverse-text-color selection-border-color shadowed text-uppercase action-btn fw-600 font-secondary next-step-btn'
      (click)='onForwardBtnClick()'>
      <span class="choice-text">{{'component.step_controls.next' | translate}}: {{forwardBtnItemLabel}}</span>
    </button>

    <div ftsAuditableButton *ngIf='hasForwardBtn && !isHalfAndHalf && (hasSubmitBtn || (isItemValid && !(viewPort$ | async)?.isMobile)) && ingredientChoicesType === ingredientChoicesTypeEnum.Steps'
      class='button-wrapper step-controls-or-separator font-secondary fw-600 padded-left-10 padded-right-10 text-uppercase'>
      <span>{{'component.step_controls.or' | translate}}</span>
    </div>

    <button 
      ftsAuditableButton
      *ngIf='!isHalfAndHalf && (hasSubmitBtn || isItemValid)' ftsAsyncButton [subscription]='submitLoadingSubscription'
      class='btn action-bg-color action-inverse-text-color shadowed action-btn font-secondary submit-btn text-uppercase margin-right-10'
      (click)="onSubmitBtnClick()">
      {{submitBtnLabel}}
    </button>
  </div>
</div>